import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Heading,
  Image,
  Text,
} from "@chakra-ui/react";
import React from "react";
import "./projects.css";
import image from "../Images/digitron.png";
import { Link } from "react-router-dom";
import OtherProject from "./OtherProject";

function Project() {
  const techstax = [
    "HTML",
    "CSS",
    "Javascript",
    "React JS",
    "Tailwind CSS",
    "Chakra UI",
    "Node JS",
    "Express JS",
  ];

  return (
    <Box id="projects">
      <Box w={"92%"} m={"auto"} className="project-card">
        <Heading className="project_heading" as={"h1"} size={"xl"}>
          My Projects
        </Heading>
        <Box mt={"20px"}>
          <Heading as={"h2"} size={"lg"} textAlign={"left"} className="latest">
            My latest project
          </Heading>
          <Box
            w={"100%"}
            mt={"10"}
            m={"auto"}
            display={"flex"}
            flexDirection={{
              base: "column",
              sm: "column",
              md: "column",
              lg: "row",
              xl: "row",
              "2xl": "row",
            }}
            justifyContent={"space-around"}
          >
            <Box className="image-box" m={"auto"}>
              <Image src={image} />
            </Box>
            <Box
              id="project-description"
              className="project-description"
              m={"auto"}
            >
              <Box textAlign={"left"}>
                <Box
                  display={"flex"}
                  justifyContent={"flex-start"}
                  alignItems={"center"}
                >
                  <Button colorScheme="blue" size={"sm"}>
                    Collaborative
                  </Button>
                </Box>
                <br />
                <Grid
                  gridTemplateColumns={{
                    base: "repeat(2, 1fr)",
                    sm: "repeat(3, 1fr)",
                    md: "repeat(3, 1fr)",
                    lg: "repeat(4, 1fr)",
                    xl: "repeat(5, 1fr)",
                    "2xl": "repeat(5, 1fr)",
                  }}
                  justifyContent={"center"}
                  gap={"4"}
                >
                  {techstax.map((el, ind) => {
                    return (
                      <GridItem display={"flex"} justifyContent={"left"}>
                        <Button
                          className="project-tech-stack"
                          colorScheme={"teal"}
                          size={"sm"}
                          p={"2"}
                          borderRadius={"8"}
                        >
                          {el}
                        </Button>
                      </GridItem>
                    );
                  })}
                </Grid>
              </Box>
              <Box textAlign={"left"} mt={"8px"}>
                <Heading as={"h2"} size={"lg"} className="project-title">
                  Digitron
                </Heading>
                <Text>
                  Digitron: Your Gateway to Interview Success! Unlock your
                  potential with our immersive interview environment designed to
                  help you excel in your job interviews. Practice, prepare, and
                  boost your confidence with our comprehensive platform.
                </Text>
                <Box display={"flex"} justifyContent={"center"} mt={"5"}>
                  <Flex>
                    <Link
                      target="_blank"
                      to={"https://github.com/Payalsahuj/Digitron"}
                    >
                      <Button
                        p={"2"}
                        pl={"5"}
                        pr={"5"}
                        color={"white"}
                        colorScheme="blue"
                        fontSize={"md"}
                        fontWeight={"bold"}
                        fontStyle={"oblique"}
                        cursor={"pointer"}
                        className="project-github-link"
                      >
                        GitHub 🧑‍💻
                      </Button>
                    </Link>
                    <Link
                      to={
                        "https://64b2395bb301bd56758a1dbf--transcendent-kataifi-01bde5.netlify.app/"
                      }
                      target="_blank"
                    >
                      <Button
                        cursor={"pointer"}
                        ml={"5"}
                        p={"2"}
                        pl={"5"}
                        pr={"5"}
                        borderRadius={"8"}
                        fontSize={"md"}
                        fontWeight={"bold"}
                        fontStyle={"oblique"}
                        className="project-deployed-link"
                      >
                        Depoloyment 🔗
                      </Button>
                    </Link>
                  </Flex>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box w={"92%"} m={"auto"} className="project_card2">
        <Heading as={"h2"} size={"lg"} textAlign={"left"} className="others">
          Some Of The Other Projects
        </Heading>
        <Box>
          <OtherProject />
        </Box>
      </Box>
    </Box>
  );
}

export default Project;
